import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Table, Button,Row,Col,Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { listVisitorReport } from '../Network/Visitor';
import { AlertModalContext } from '../Library/AlertModalContext'
import { NotifyContext } from '../Library/Notify'
import "./UserLinkroom.css"
import axios from 'axios'
import { visitor8082 } from '../Network/Config'
import DatePicker from "react-datepicker";

function UserLinkroom(props) {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.linkroom
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [visitorReportList, setVisitorReportList] = useState([])
    const [companyName, setCompanyName] = useState("")
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [securityVisitor, setSecurityVisitor] = useState([])
    const [userList, setUserList] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null) 

    useEffect(() => {
        const fetchUserList = async () => {
            if (!props.token) return;
    
            try {
                setIsLoading(true)
                console.log('Token : ', props.token)
                const headers = {
                    'Authorization': props.token,
                };
                const userListData = await axios.post(
                    'https://visitor-api.lifelink.co.th:10443/linkroom/api/admin/v1/listuser',
                    null,
                    { headers }
                );
                setUserList(userListData.data.data);
                setIsLoading(false)
            } catch (e) {
                console.error(e);
                setIsLoading(false)
            }
        };
    
        fetchUserList();
    }, [props.token]);
        

    const formattedDate = (date) => {
        const dateFormatted = dayjs(date).format("D MMM YYYY - H:mm")
        return dateFormatted
    }

    const deleteUserFromList =  (id)  =>{
        alertModal.setTitle(lang.deleteuser)
        alertModal.setDescription(lang.suredeleteuser)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: async () =>{ 
                    alertModal.setIsShow(false)
                    setIsLoading(true)
                    const formData = new FormData();
                    formData.append('user_id', id);
                    const headers = {
                        'Authorization': props.token,
                    };
                    await axios.post('https://visitor-api.lifelink.co.th:10443//linkroom/api/admin/v1/deleteuser', formData ,{ headers });
                    history.go(0)
                    setIsLoading(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        
        alertModal.setIsShow(true)
    }

    const UserListItem = ({ email,firstname,lastname,phone, type, onDeleteClick }) => {
        return(
            <tr>
                <td></td>
                <td>{email}</td>
                <td>{firstname +"   " +lastname}</td>
                <td>{phone}</td>
                <td>{type.charAt(0).toUpperCase() + type.slice(1)}</td>
                <td>
                    {
                    <div className="action-container">
                        <Button size="sm" variant="danger" style={{marginLeft: 10}}
                        onClick={onDeleteClick}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button> 
                    </div>
                    }
                </td>
            </tr>
        )
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>{lang.linkroomUser}</div>
                    <div style={{justifyContent:'flex-end'}}>
                        <Button onClick={()=>history.push("/users/create")}>{lang.addUser}</Button>
                    </div>
                </div>
            </div>
            {/*
            <div>
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            </div>
            */}
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.email}</th>
                            <th>{lang.firstname+' '+lang.lastname}</th>
                            <th>{lang.phone}</th>
                            <th>{lang.type}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        { userList.map((item, key) =>
                        <UserListItem
                        key={key}
                        email={item.email}
                        firstname={item.firstname}
                        lastname={item.lastname}
                        phone={item.phone}
                        type={item.type}
                        //onEditClick={()=>history.push("/visitor_security/edit/"+item.security_id)}
                        onDeleteClick={()=>deleteUserFromList(item.user_id)}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default UserLinkroom;
